import type { TProductsElement } from '@shared/dream-components/src';

import type { NodeContent } from '~/interfaces/page';

import { findTipTapContentNode } from '../findTipTapContentNode';

function findProductIdsProductNodes(productNodes: TProductsElement[]) {
  const productIds = new Set<string>([]);

  productNodes
    .filter((productNode) => !productNode.attrs.hasFakeData)
    .forEach((productNode) => {
      if (!productNode.attrs.structureTiptapState) {
        return;
      }

      const ratingNode = findTipTapContentNode(
        productNode.attrs.structureTiptapState as NodeContent,
        'paragraph',
        (node) => (node as { attrs?: { mergeTag?: string } }).attrs?.mergeTag === 'product.rating',
      );
      if (!ratingNode) {
        return;
      }

      productNode.attrs.data.products.forEach((product) => {
        productIds.add(product.id);
      });
    });

  return [...productIds];
}

export { findProductIdsProductNodes };
